/**
 * Id opaco para el header `x-request-id` de las llamadas a psiplatform-be: el backend lo registra en sus logs de
 * errores (5xx) y Métricas de Actividad lo guarda junto al error, así se encuentra en Cloud Run la llamada que falló.
 * Letras, números y guiones (un uuid cumple); nunca lleva datos de la persona ni de la llamada.
 */
export const REQUEST_ID_PATTERN = /^[A-Za-z0-9-]{8,64}$/;

export function newRequestId(): string {
  try {
    const c = (globalThis as { crypto?: { randomUUID?: () => string } }).crypto;
    if (c?.randomUUID) return c.randomUUID();
  } catch {
    /* sin crypto: se usa el respaldo */
  }
  // Respaldo (navegadores viejos / entornos sin crypto.randomUUID): 32 caracteres hexadecimales.
  return Array.from({ length: 32 }, () => Math.floor(Math.random() * 16).toString(16)).join("");
}
